import React from 'react';
import { FiDownload, FiExternalLink, FiAlertCircle } from 'react-icons/fi';
import Navbar from '../Nav';
import './Resume.css';

// Prefer local file if added to /public/resume.pdf to avoid Drive embed issues
// Cache-bust with a version query to pick up new uploads.
// In Create React App, files in /public are served from root
const RESUME_URL = `${process.env.PUBLIC_URL || ''}/khan_cv.pdf?v=2024-11-21-2`;
const RESUME_DL = 'https://drive.google.com/uc?export=download&id=1pPAH4nRXK_qcZbaW_kmkxP_VErsDci0B';
const RESUME_FALLBACK_VIEW = 'https://drive.google.com/file/d/1pPAH4nRXK_qcZbaW_kmkxP_VErsDci0B/view?usp=sharing';
// https://drive.google.com/file/d/1pPAH4nRXK_qcZbaW_kmkxP_VErsDci0B/view?usp=sharing
function ResumePage() {

  return (
    <div className="resume-page">
      <Navbar />
      <main className="resume-wrapper">
        <header className="resume__header">
          <p className="resume__label">Resume</p>
          <h1 className="resume__title">Afraz Khan — CS (RL, Applied ML, Backend)</h1>
          <p className="resume__subtitle">
            View the PDF inline below. If the embed is blocked, use the new tab or download options.
          </p>
          <div className="resume__actions">
            <a className="resume__btn" href={RESUME_DL} target="_blank" rel="noreferrer">
              <FiDownload aria-hidden="true" /> Download PDF
            </a>
            <a className="resume__btn" href={RESUME_FALLBACK_VIEW} target="_blank" rel="noreferrer">
              <FiExternalLink aria-hidden="true" /> Open in new tab
            </a>
            <a className="resume__btn" href={RESUME_URL} target="_blank" rel="noreferrer">
              <FiExternalLink aria-hidden="true" /> Open PDF directly
            </a>
          </div>
        </header>

        <div className="resume__frame">
          <object
            className="resume__iframe"
            data={RESUME_URL}
            type="application/pdf"
            aria-label="Afraz Khan Resume"
          >
            <iframe
              className="resume__iframe"
              src={RESUME_URL}
              title="Afraz Khan Resume"
            />
          </object>
          <div className="resume__notice">
            <FiAlertCircle aria-hidden="true" />
            <span>If the PDF doesn't load, open in a new tab or download above. For best results, place `resume.pdf` in /public.</span>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ResumePage;
